package org.example.project.enginevertrieb

import androidx.compose.runtime.*
import kotlinx.coroutines.delay
import org.example.project.settings.UISettings
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
internal fun SalesCheckpointTileRow(content: @Composable () -> Unit) {
    Div({ style { display(DisplayStyle.Flex); flexWrap(FlexWrap.Wrap); justifyContent(JustifyContent.Center)
        gap(8.px); padding(10.px, 12.px); marginBottom(16.px); flexShrink(0); maxHeight(240.px); overflowY("auto") } }) { content() }
}

@Composable
internal fun SalesCheckpointTile(checkpoint: SalesCheckpoint, count: Int, due: Int?, selected: Boolean,
    enabled: Boolean, title: String, callStartedAt: String? = null, onSelect: () -> Unit) {
    var now by remember { mutableStateOf(kotlin.js.Date.now()) }
    LaunchedEffect(callStartedAt) {
        if (callStartedAt != null) while (true) { now = kotlin.js.Date.now(); delay(1000) }
    }
    Div({
        attr("aria-label", title); attr("role", "button"); attr("tabindex", if (enabled) "0" else "-1")
        attr("aria-pressed", selected.toString()); attr("aria-disabled", (!enabled).toString()); attr("title", title)
        onClick { if (enabled) onSelect() }
        onKeyDown { if (enabled && (it.key == "Enter" || it.key == " ")) { it.preventDefault(); onSelect() } }
        style {
            display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(10.px); width(164.px)
            padding(10.px, 12.px); borderRadius(8.px)
            backgroundColor(Color(if (selected) "#465b70" else UISettings.SALES_KPI_BG))
            property("cursor", if (enabled) "pointer" else "default")
            property("border", if (selected) "1px solid rgba(255,255,255,.65)" else "1px solid transparent")
        }
    }) {
        Img(src = "images/${checkpoint.icon}.svg", attrs = {
            attr("alt", ""); style { width(26.px); height(26.px); flexShrink(0); property("filter", when (checkpoint.id) {
                "IN_CALL" -> if (count > 0) "brightness(0) saturate(100%) invert(72%) sepia(65%) saturate(605%) hue-rotate(82deg)" else "brightness(0) invert(1)"
                "CLOSED_POSITIVE" -> "brightness(0) saturate(100%) invert(72%) sepia(65%) saturate(605%) hue-rotate(82deg)"
                "CLOSED_NEGATIVE" -> UISettings.ICON_FILTER_ACCENT
                else -> "brightness(0) invert(1)"
            }) }
        })
        Div({ style { flex("1"); textAlign("center"); display(DisplayStyle.Grid); gridTemplateRows("18px 30px 18px") } }) {
            Div({ style { fontSize(12.px); lineHeight("18px") } }) { Text(checkpoint.label) }
            Div({ style { fontSize(25.px); fontWeight("700"); lineHeight("30px") } }) { Text(count.toString()) }
            Div({ style { fontSize(12.px); lineHeight("18px") } }) {
                if (checkpoint.id == "IN_CALL" && callStartedAt != null) {
                    val started = kotlin.js.Date(callStartedAt).getTime()
                    val seconds = if (started.isNaN()) 0L else ((now - started) / 1000).toLong().coerceAtLeast(0)
                    Text("${(seconds / 3600).toString().padStart(2, '0')}:${(seconds / 60 % 60).toString().padStart(2, '0')}:${(seconds % 60).toString().padStart(2, '0')}")
                } else if (checkpoint.id in setOf("CLOSED_POSITIVE", "CLOSED_NEGATIVE")) {
                    Span({ style { fontWeight("700") } }) {
                        Text(checkpoint.actionLabel)
                    }
                } else if (due != null) {
                    Text("Follow-up: ")
                    Span({ style { color(Color("#ff6262")); fontWeight("700") } }) { Text(due.toString()) }
                }
            }
        }
    }
}
